import angular from "angular";

angular
    .module('app')
    .component('courseCreateForm', {
        template: require('./course-create-form.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.title = null;
    $ctrl.category = null;

    $ctrl.$onInit = function () {
        $ctrl.categories = $ctrl.resolve.categories;
    };

    $ctrl.submit = function () {

        if ($ctrl.loading) {
            return;
        }

        if (!$ctrl.category) {
            alert('Category not selected');
            return;
        }

        let params = {
            title: $ctrl.title,
            category_id: $ctrl.category.id,
        };

        $ctrl.loading = true;

        $http
            .post('/admin/courses', params)
            .then(
                function (response) {
                    let id = response.data.id;
                    $ctrl.close({
                        $value: {
                            id: id,
                            title: $ctrl.title,
                            category: $ctrl.category
                        }
                    });
                },
                function (error) {
                    $ctrl.loading = false;
                    alert(error);
                }
            )
    }
}
